import axios from "axios";
import { Form, Popup } from "devextreme-react";
import { EmptyItem, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import { ToolbarItem } from "devextreme-react/popup";
import DataSource from "devextreme/data/data_source";
import { useCallback, useEffect, useRef, useState } from "react";

export default function StudyInfo(props) {
  const { sales, studyInfoPopupVisible, setStudyInfoPopupVisible } = props;

  const formStudyInfoRef = useRef(null);

  const [studyInfoDataSource, setStudyInfoDataSource] = useState(null);
  const [usesIndicationDataSource, setUsesIndicationDataSource] =
    useState(null);
  const [usesIndicationEngDataSource, setUsesIndicationEngDataSource] =
    useState(null);
  const [phaseStepDataSource, setPhaseStepDataSource] = useState(null);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/studyInfo/usesIndic?lang=kor`
    );

    setUsesIndicationDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "value",
        },
      })
    );

    const result2 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/studyInfo/usesIndic?lang=eng`
    );

    setUsesIndicationEngDataSource(
      new DataSource({
        store: {
          data: result2.data,
          type: "array",
          key: "value",
        },
      })
    );

    const result3 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/studyInfo/phaseStep`
    );

    setPhaseStepDataSource(
      new DataSource({
        store: {
          data: result3.data,
          type: "array",
          key: "value",
        },
      })
    );
  }, []);

  useEffect(async () => {
    if (sales.contrNo) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/studyInfo/${sales.contrNo}`
      );

      setStudyInfoDataSource(result.data);
    }
  }, [sales.contrNo]);

  const onHiding = () => {
    setStudyInfoPopupVisible(false);
  };

  const onSaveClick = useCallback(async () => {
    // console.debug("[onSaveClick]");

    await axios.put(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/studyInfo/${sales.contrNo}`,
      studyInfoDataSource
    );

    setStudyInfoPopupVisible(false);
  }, [studyInfoDataSource]);

  const onUsesIndicationCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      value: args.text,
    };

    args.customItem = usesIndicationDataSource
      .store()
      .insert(newItem)
      .then(() => usesIndicationDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const onUsesIndicationEngCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      value: args.text,
    };

    args.customItem = usesIndicationEngDataSource
      .store()
      .insert(newItem)
      .then(() => usesIndicationEngDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const onPhaseStepCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      value: args.text,
    };

    args.customItem = phaseStepDataSource
      .store()
      .insert(newItem)
      .then(() => phaseStepDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const onSeoulGyeonggiValueChanged = (e) => {
    setStudyInfoDataSource((prevState) => ({
      ...prevState,
      "Number of Clinical Sites":
        parseInt(e.value) + parseInt(prevState["Distant provinces"]),
    }));
  };

  const onDistantProvincesValueChanged = (e) => {
    setStudyInfoDataSource((prevState) => ({
      ...prevState,
      "Number of Clinical Sites":
        parseInt(e.value) + parseInt(prevState["Seoul/Gyeonggi"]),
    }));
  };

  return (
    <div className="tabpanel-item">
      <div>
        {sales.contrNo && studyInfoDataSource && (
          <table>
            <tbody>
              <tr>
                <th>Protocol No.:</th>
                <td>
                  <b>{studyInfoDataSource.protocolNo}</b>
                </td>
                <th>Phase Step:</th>
                <td>
                  <b>{studyInfoDataSource["Phase Step"]}</b>
                </td>
              </tr>
              <tr>
                <th>Study Title/Project Name:</th>
                <td colSpan={3}>
                  <b>{studyInfoDataSource.name}</b>
                </td>
              </tr>
              <tr>
                <th>Uses/Indication:</th>
                <td colSpan={3}>
                  <b>
                    {studyInfoDataSource["Uses/Indication"]}
                    {studyInfoDataSource["Uses/Indication Eng"]
                      ? `(${studyInfoDataSource["Uses/Indication Eng"]})`
                      : ``}
                  </b>
                </td>
              </tr>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Number of Clinical Sites:
                  {studyInfoDataSource["Number of Clinical Sites"]} Sites
                </td>
              </tr>
              <tr>
                <th>Seoul/Gyeonggi:</th>
                <td>
                  <b>{studyInfoDataSource["Seoul/Gyeonggi"]} Sites</b>
                </td>
                <th>Distant Provinces:</th>
                <td>
                  <b>{studyInfoDataSource["Distant provinces"]} Sites</b>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      {sales.contrNo && studyInfoDataSource && (
        <Popup
          visible={studyInfoPopupVisible}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          width={1200}
          height={"auto"}
          title="Study Info"
          onHiding={onHiding}
        >
          <ToolbarItem
            widget={"dxButton"}
            toolbar={"top"}
            location={"after"}
            options={{
              icon: "save",
              type: "normal",
              stylingMode: "contained",
              onClick: onSaveClick,
            }}
          />
          <Form
            id="form-studyInfo"
            ref={formStudyInfoRef}
            formData={studyInfoDataSource}
            colCount={4}
            labelMode="outside"
            labelLocation="top"
            showColonAfterLabel={true}
            style={{
              padding: "16px",
            }}
            validationGroup="studyInfoData"
          >
            <SimpleItem
              dataField={"protocolNo"}
              editorType={"dxTextBox"}
              editorOptions={{
                showClearButton: true,
              }}
            >
              <Label text={"Protocol No."} />
            </SimpleItem>
            <SimpleItem
              dataField={"name"}
              colSpan={3}
              editorType={"dxTextBox"}
              editorOptions={{
                showClearButton: true,
              }}
            >
              <Label text={"Study Title/Project Name"} />
            </SimpleItem>
            <SimpleItem
              dataField={"Uses/Indication"}
              // colSpan={2}
              editorType={"dxSelectBox"}
              editorOptions={{
                showClearButton: true,
                dataSource: usesIndicationDataSource,
                displayExpr: "value",
                valueExpr: "value",
                acceptCustomValue: true,
                onCustomItemCreating: onUsesIndicationCustomItemCreating,
              }}
            >
              <Label text={"Uses/Indication"} />
            </SimpleItem>
            <SimpleItem
              dataField={"Uses/Indication Eng"}
              // colSpan={2}
              editorType={"dxSelectBox"}
              editorOptions={{
                showClearButton: true,
                dataSource: usesIndicationEngDataSource,
                displayExpr: "value",
                valueExpr: "value",
                acceptCustomValue: true,
                onCustomItemCreating: onUsesIndicationEngCustomItemCreating,
              }}
            >
              <Label text={"Uses/Indication Eng"} />
            </SimpleItem>
            <SimpleItem
              dataField={"Phase Step"}
              colSpan={2}
              editorType={"dxSelectBox"}
              editorOptions={{
                showClearButton: true,
                dataSource: phaseStepDataSource,
                displayExpr: "value",
                valueExpr: "value",
                acceptCustomValue: true,
                onCustomItemCreating: onPhaseStepCustomItemCreating,
              }}
            >
              <Label text={"Phase Step"} />
            </SimpleItem>
            <GroupItem
              caption={`Number of Clinical Sites:  ${studyInfoDataSource["Number of Clinical Sites"]} Sites`}
              colSpan={4}
              colCount={4}
            >
              <SimpleItem
                dataField={"Seoul/Gyeonggi"}
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  onValueChanged: onSeoulGyeonggiValueChanged,
                }}
              >
                <Label text={"Seoul/Gyeonggi"} />
              </SimpleItem>
              <SimpleItem
                dataField={"Distant provinces"}
                editorType={"dxNumberBox"}
                editorOptions={{
                  showClearButton: true,
                  onValueChanged: onDistantProvincesValueChanged,
                }}
              >
                <Label text={"Distant provinces"} />
              </SimpleItem>
            </GroupItem>
          </Form>
        </Popup>
      )}
    </div>
  );
}
